<template>
  <transition name="dawn-modal" @beforeEnter="onbeforeshow" @afterEnter="onshow">
    <div class="dawn-modal-mask" :class="flat ? 'flat' : ''" v-if="show">
      <div :class='["dawn-modal-container", type]' v-on-clickaway='handleClose' :endpoint="$attrs.modalEndpoint">
        <div class="dawn-modal-top">
          <span class="close-icon pull-right" @click="close" title="Close"><i class="fal fa-times" /></span>
        </div>
        <div class="dawn-modal-header">
          <h3 class="title">{{title}}</h3>
          <p class="subtitle">{{subtitle}}</p>
        </div>
        <div class="clearfix"></div>
        <slot name="body" />
        <div class="dawn-modal-footer text-right">
          <slot name="footer" />
          <div v-if="!hasSlotFooter">
            <ed-button class="additionalButtonClass" @click="additionalAction" v-if="additionalButton != 'false' && additionalButton != ''">{{additionalButton}}</ed-button>
            <ed-button class="btn btn-secondary" @click="close(true)"  v-if="secondaryButton != 'false'">{{secondaryButton}}</ed-button>
            <ed-button :class="primaryButtonClass"
                       :endpoint='$attrs.submitEndpoint'
                       @click="confirm"
                       v-if="primaryButton != 'false' && !validation"
                       :disabled='primaryButtonDisabled'>
              {{primaryButton}}
            </ed-button>
            <ed-button :class="primaryButtonClass"
                       :endpoint='$attrs.submitEndpoint'
                       @click="validate"
                       v-if="primaryButton != 'false' && validation"
                       :disabled='primaryButtonDisabled'>
              {{primaryButton}}
            </ed-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

import { EventBus } from '@/event-bus'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'ed-modal',

  mixins: [ clickaway ],

  props: {
    show           : { type: Boolean, default: false },
    title          : { type: String, required: true },
    subtitle       :         String,
    primaryButton  : { type: String, default: 'Ok' },
    primaryButtonClass: { type: String, default: 'btn btn-primary' },
    additionalButtonClass: { type: String, default: 'btn btn-dark' },
    secondaryButton: { type: String, default: 'Cancel' },
    additionalButton: { type: String, default: '' },
    type           :         String,
    validation     : { type: Boolean, default: false },
    primaryButtonDisabled : { type: Boolean, default: false },
    closeOnClickAway: Boolean,
    flat: Boolean
  },

  data() {
    return {
      body  : null,
      footer: null
    }
  },

  computed: {
    hasSlotFooter: function () { return this.$slots.footer }
  },

  mounted() {
    document.addEventListener('keydown', (e) => {
      if (this.show && e.keyCode === 27) {
        this.closeOnClickAway && this.$emit('close')
      }
    })
  },

  methods: {
    onbeforeshow: function() {
      this.$emit('beforeshow')
    },

    onshow: function() {
      this.$emit('show')
      EventBus.$emit('modal-show')
    },

    close: function (btnClick) {
      this.$emit('close', { btnClick: typeof btnClick === 'boolean' ? btnClick : false })
    },

    confirm: function () {
      this.$emit('confirm')
      this.close()
    },

    additionalAction: function () {
      this.$emit('additionalAction')
      this.close()
    },

    validate: function () {
      this.$emit('validate')
    },

    handleClose() {
      this.closeOnClickAway && this.$emit('close')
    }
  }
}
</script>

<style scoped lang='scss'>
  @import "~@/assets/sass/_variables.scss";

  .clearfix {
    height: 1px;
    margin-top: -1px;
  }

.dawn-modal-mask {
  position: fixed;
  z-index: 1000000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(120, 87, 132, 0.3);
  transition: opacity .3s ease;
  overflow: auto;
  padding-bottom: 40px;

  &.middle .dawn-modal-container {
    margin-top: 15%;
  }

  &.flat {
    background-color: transparent;
  }

  .dawn-modal-container {
    margin-top: 0.5rem;
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);
  }
}

.standard .dawn-modal-container {
  width: 640px;
}

.dawn-modal-container {
  width: 500px;
  margin: 4rem auto 0;
  padding: 1rem 1.5rem;
  @include theme {
  background: v(canvas);
  }
  border-radius: $border-radius;
  box-shadow: $box-shadow;
  transition: all .3s ease;

  h3.title {
    font-weight: $font-weight-extra-bold;
    font-size: $font-size-large;

    margin-top: 0;
    margin-bottom: 0.5rem;
  }

  p.subtitle {
    font-weight: normal;
    font-size: $font-size-base;
  }

  &.small {
   width: 300px;
  }
  &.extra-small {
   width: 464px;
  }
  &.medium {
   width: 800px;
  }
  &.small-medium {
    width: 600px;
  }
  &.medium-large {
    width: 900px;
  }
  &.large {
   width: 1100px;
  }

  &.extra-large {
    width: 1400px;
  }

  &.full-width {
    width: 100%;
  }
}

.dawn-modal-top {
  span.close-icon {
    font-weight: 100;
    @include theme {
    color: v(ink);
    }
    margin-left: 2rem;
    text-align: right;
    &:hover {
      cursor: pointer;
    }
  }
}

.dawn-modal-body {
  margin: 1rem 0;
}

.text-right {
  text-align: right;
}

.dawn-modal-enter {
  opacity: 0;
}

.dawn-modal-leave-active {
  opacity: 0;
}

.dawn-modal-enter .dawn-modal-container,
.dawn-modal-leave-active .dawn-modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>



// WEBPACK FOOTER //
// src/core/components/edModal/index.vue